class ExpressionParser{
  static analiseZombiePart(zombiePart){
    let connector = '';
    let subString = '';
    const lastSpaceIndex = zombiePart.trim().lastIndexOf(' ');
    const zombieConnectorWord = zombiePart.substring(lastSpaceIndex, zombiePart.lenght).trim().toLowerCase();
    switch(zombieConnectorWord.trim().toLowerCase()){
      case 'and': subString = ' {"rulePart":"' + zombiePart.substring(0,lastSpaceIndex).trim() + '"},'; connector += '{"connector": "AND"},'; break;
      case 'or':  subString = ' {"rulePart":"' + zombiePart.substring(0,lastSpaceIndex).trim() + '"},'; connector += '{"connector": "OR"},'; break;
      default: subString = ' {"rulePart":"' + zombiePart + '"},'; break;
    }
    return subString + connector;
  }

  static parseRule(rule){
    let resultObject = {};
    let deep = 0;
    let insideString = false;
    let parsedJsonObject = '[';
    let subString = '';
    let quoteReplacement = "%%QUOTE%%";

    if (rule === undefined || rule === null || rule === '') {
      resultObject.isValid = true;
      resultObject.jsonObject = "";
      return resultObject;
    }

    rule = rule.replace(/["']/g, quoteReplacement);

    for (let i = 0; i < rule.length; i++) {
      let charValue = rule.charAt(i);
      let nextCharValue = rule.charAt(i+1);

      if(rule.substring(i, i + quoteReplacement.length) === quoteReplacement){
        insideString = !insideString;
      }

      if((charValue !== '{' && charValue !== '}') || insideString === true ){
        subString += rule.charAt(i);
      }

      if(insideString === false && charValue === '{' ){
        if(subString !== ''){
          switch(subString.trim().toLowerCase()){
            case 'and': parsedJsonObject += '{"connector": "AND"},'; subString = ''; break;
            case 'or':  parsedJsonObject += '{"connector": "OR"},'; subString = ''; break;
            default: parsedJsonObject += this.analiseZombiePart(subString);subString = ''; break;
          }
        }
        if(nextCharValue === '{' ){
          parsedJsonObject += ' {"subRules": [';
        }else{
          parsedJsonObject += ' {"rulePart":';
        }
        deep += 1;

      }

      if(insideString === false && charValue === '}' ){
        if(subString !== ''){
          subString = '"'+ subString +'"';
        }
        if(nextCharValue === '}' ){
          parsedJsonObject += subString +'}]';
        }else{
          parsedJsonObject += subString +'},';
        }
        subString = '';
        deep -= 1;
      }
    }

    if(parsedJsonObject === '['){
      parsedJsonObject += this.analiseZombiePart(subString);
    }

    resultObject.jsonObject = parsedJsonObject = parsedJsonObject.substring(0,parsedJsonObject.length-1)+']';
    resultObject.jsonObject = parsedJsonObject.replace(new RegExp(quoteReplacement, "g"), "'");

    resultObject.isValid = true;

    if(deep > 0){
      resultObject.isValid = false;
    }

    return resultObject;
  }
}

export default ExpressionParser;



// WEBPACK FOOTER //
// ./src/shared/helpers/ExpresionParser.js